import {
    Dashboard,
    School,
    CalendarMonth,
    DateRange,
    Layers,
    AccountTree,
    WorkOutline,
    Badge,
    MenuBook,
    Class,
    SupervisedUserCircle,
    Face,
    HowToReg,
    Schema,
    AssignmentInd,
    Person,
    Security,
} from '@mui/icons-material';

export const sidebarItems = [
    { key: 'dashboard', label: { en: 'Dashboard', ar: 'لوحة التحكم' }, path: '/dashboard', icon: Dashboard },
    { key: 'schools', label: { en: 'Schools', ar: 'المدارس' }, path: '/schools', icon: School },
    { key: 'academic-years', label: { en: 'Academic Years', ar: 'السنوات الدراسية' }, path: '/academic-years', icon: CalendarMonth },
    { key: 'academic-terms', label: { en: 'Academic Terms', ar: 'الفصول الدراسية' }, path: '/academic-terms', icon: DateRange },
    { key: 'levels', label: { en: 'Levels', ar: 'المستويات' }, path: '/levels', icon: Layers },
    { key: 'departments', label: { en: 'Departments', ar: 'الأقسام' }, path: '/departments', icon: AccountTree },
    { key: 'job-titles', label: { en: 'Job Titles', ar: 'المسميات الوظيفية' }, path: '/job-titles', icon: WorkOutline },
    { key: 'employees', label: { en: 'Employees', ar: 'الموظفون' }, path: '/employees', icon: Badge },
    { key: 'teachers', label: { en: 'Teachers', ar: 'المعلمون' }, path: '/teachers', icon: MenuBook },
    { key: 'classes', label: { en: 'Classes', ar: 'الحلقات' }, path: '/classes', icon: Class },
    { key: 'guardians', label: { en: 'Guardians', ar: 'أولياء الأمور' }, path: '/guardians', icon: SupervisedUserCircle },
    { key: 'students', label: { en: 'Students', ar: 'الطلاب' }, path: '/students', icon: Face },
    { key: 'student-enrollments', label: { en: 'Enrollments', ar: 'التسجيلات' }, path: '/student-enrollments', icon: HowToReg },
    { key: 'org-structure-items', label: { en: 'Org Structure', ar: 'الهيكل التنظيمي' }, path: '/org-structure-items', icon: Schema },
    { key: 'org-structure-assignments', label: { en: 'Structure Assignments', ar: 'تعيينات الهيكل التنظيمي' }, path: '/org-structure-assignments', icon: AssignmentInd },
    { key: 'users', label: { en: 'Users', ar: 'المستخدمون' }, path: '/users', icon: Person },
    { key: 'roles', label: { en: 'Roles', ar: 'الأدوار' }, path: '/roles', icon: Security },
];
